<template>
  <Tooltip
    v-bind="tooltips"
    :content="content"
  >
    <Icon v-bind="localIcon" />
    <template
      v-if="$slots.default"
      #content
    >
      <slot />
    </template>
  </Tooltip>
</template>

<script lang="ts">
  import {
    computed, defineComponent,
  } from 'vue'
  import { merge } from 'lodash'
  import Icon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import Tooltip from './Tooltip.vue'

  export default defineComponent({
    name: 'IconToolTip',
    components: {
      Tooltip,
      Icon,
    },
    props: {
      icon: {
        type: Object,
        default: () => ({}),
      },
      content: {
        type: [String, Function, Array],
      },
    },
    setup(prop, { attrs }) {
      return {
        tooltips: computed(() => merge({
          bs: {
            'cmp.iconTooltip': 'wrapper',
          },
        }, attrs)),
        localIcon: computed(() => merge({
          icon: 'info',
          size: 14,
          bs: {
            verticalAlign: 'bottom',
            'cmp.iconTooltip': 'icon',
            fill: 'ash',
            '&:hover': {
              fill: 'brand',
            },
          },
        }, prop.icon)),
      }
    },
  })
</script>
